import { call } from 'vuex-pathify';
import { GeoJSON } from 'ol/format';
import { getArea } from 'ol/sphere';
import turfUnion from '@turf/union';
export default {
  data: () => ({
    currentJoinPolygonsEditFeatureId: null,
    currentJoinPolygonsDeleteFeaturesIds: [],
    currentJoinPolygonsNewGeometry: null,
    isJoiningPolygonsButtonLoading: false,
  }),
  methods: {
    deleteNotTopoFeaturesAction: call('layers/deleteDatasourceFeatures'),
    deleteTopoFeaturesAction: call('layers/deleteTopoDatasourceFeatures'),
    editTopoFeatureAction: call('layers/editTopoDatasourceFeature'),
    editNonTopoFeatureAction: call('layers/editDatasourceFeature'),
    getLayerFeatures: call('layers/getLayerFeatures'),
    async joinPolygons() {
      this.isJoiningPolygonsButtonLoading = true;
      const payload = {
        layer_id: this.layerId,
        features_filter: this.getJoinPolygonsFilter(this.selectedFeatures),
        params: {
          with_features: true,
          with_collection_bbox: false,
          with_count: false,
          with_geometry: true,
        },
      };
      const features = (await this.getLayerFeatures(payload)).data?.data?.features;
      const featuresGeometries = features.features.map(feature => {
        return { ...feature.geometry, crs: features.crs };
      });
      const union = featuresGeometries.reduce(
        (geometryA, geometryB) => turfUnion(geometryA, geometryB),
        featuresGeometries[0]
      );
      const unionGeometry = { ...union.geometry, crs: features.crs };

      if (unionGeometry.type === 'MultiPolygon' && this.geometryType === 'polygon') {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.polygonsMustIntersect'),
        });
        this.isJoiningPolygonsButtonLoading = false;
      } else {
        let maxAreaGeom = { geom: '', area: 0, featureId: null };
        features.features.forEach(feature => {
          const geometry = { ...feature.geometry, crs: features.crs };
          const olGeometry = new GeoJSON().readGeometry(geometry, {
            dataProjection: this.$_config.defaultEpsg,
            featureProjection: this.$_config.defaultEpsg,
          });
          const area = getArea(olGeometry);
          if (area > maxAreaGeom.area) {
            maxAreaGeom = { geom: geometry, area, featureId: feature.id };
          }
        });
        this.openJoinPolygonsConfirmationDialog({
          editFeatureId: maxAreaGeom.featureId,
          deleteFeaturesIds: features.features
            .map(feature => feature.id)
            .filter(featureId => featureId != maxAreaGeom.featureId),
          newGeometry: unionGeometry,
        });
        this.isJoiningPolygonsButtonLoading = false;
      }
    },
    getJoinPolygonsFilter(featuresIds) {
      const idAttrbuteFilterName = this.currentLayerDataSourceUseQualifiedNames
        ? this.currentLayerIdAttributeName
        : `${this.datasource}.${this.currentLayerIdAttributeName}`;
      return {
        $IN: {
          [idAttrbuteFilterName]: featuresIds,
        },
      };
    },
    openJoinPolygonsConfirmationDialog({ editFeatureId, deleteFeaturesIds, newGeometry } = {}) {
      this.currentJoinPolygonsEditFeatureId = editFeatureId;
      this.currentJoinPolygonsDeleteFeaturesIds = deleteFeaturesIds;
      this.currentJoinPolygonsNewGeometry = newGeometry;
      this.agreeButtonLoading = false;
      this.openDialog('joinPolygons');
    },
    joinPolygonsHandler() {
      if (this.isTopo) {
        this.joinTopoFeatures({ geomName: 'geometry' });
      } else {
        this.joinNonTopoFeatures({ geomName: this.geometryPropertyName });
      }
    },
    async joinTopoFeatures({ geomName } = {}) {
      const r = await this.joinFeaturesHandler({
        deleteAction: this.deleteTopoFeaturesAction,
        editAction: this.editTopoFeatureAction,
        geomName,
      });
      this.$root.$emit(
        'refreshMvtSources',
        r.data.data.map(layer => ({ id: layer, group: 'layers' })),
        true
      );
    },
    async joinNonTopoFeatures({ geomName } = {}) {
      await this.joinFeaturesHandler({
        deleteAction: this.deleteNotTopoFeaturesAction,
        editAction: this.editNonTopoFeatureAction,
        geomName,
      });
      this.$root.$emit('refreshMvtSource', this.layerId);
    },
    async joinFeaturesHandler({ deleteAction, editAction, geomName } = {}) {
      this.agreeButtonLoading = true;
      try {
        const editPayload = {
          datasource: this.datasource,
          id: this.currentJoinPolygonsEditFeatureId,
          body: {
            [geomName]: this.currentJoinPolygonsNewGeometry,
            properties: {},
          },
          params: { layer_id: this.layerId },
        };
        const deletePayload = {
          datasource: this.datasource,
          payload: { to_delete: this.currentJoinPolygonsDeleteFeaturesIds },
          params: { layer_id: this.layerId },
        };
        const r = await Promise.all([editAction(editPayload), deleteAction(deletePayload)]);
        return r[0];
      } finally {
        this.$root.$emit('refreshTableData');
        this.$root.$emit('refreshFormData');
        this.agreeButtonLoading = false;
        this.isDialogVisible = false;
      }
    },
  },
};
